// prettier-ignore
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.body = document.querySelector("body");
    this.header = document.querySelector(".shopify-section-header");
    this.headerBottom = document.querySelector(".header__bottom");
    this.promoModal = document.querySelector(".search__modal");
    this.collectionList = document.querySelector(".template-404__collections");
    this.defaultContent = document.querySelector(".predictive-search__default");
    this.recentSearchesContainer = document.querySelector("[data-recent-searches]");
    this.recentSearchesList = document.querySelector("[data-recent-searches-list]");
    this.desktopInput = document.querySelector(".search__form--desktop .search__input");
    this.mobileInput = document.querySelector(".search__form--mobile .search__input");
    this.headerInput = window.innerWidth >= 990 ? this.desktopInput : this.mobileInput;
    this.desktopForm = document.querySelector(".search__form--desktop");
    this.mobileForm = document.querySelector(".search__form--mobile");
    this.searchForm = window.innerWidth >= 990 ? this.desktopForm : this.mobileForm;
    this.calcHeight();
    this.setupEventListeners();
    this.loadRecentSearches();

    window.addEventListener('resize', () => {
      this.handleResize.bind(this);
      this.calcHeight();
    });
  }

  calcHeight() {
    if (document.querySelector(".predictive-search")) {
      document.documentElement.style.setProperty(
        "--search-height",
        `calc(100 * var(--vh) - ${this.header.getBoundingClientRect().top}px)`,
      );
    }
  }

  setupEventListeners() {
    this.desktopForm.addEventListener("submit", this.onFormSubmit.bind(this));
    this.mobileForm.addEventListener("submit", this.onFormSubmit.bind(this));

    this.desktopInput.addEventListener("focus", this.onFocus.bind(this));
    this.mobileInput.addEventListener("focus", this.onFocus.bind(this));

    this.desktopInput.addEventListener("input", debounce((event) => {
      this.mobileInput.value = this.desktopInput.value;
      this.onChange(event);
    }, 500).bind(this));

    this.mobileInput.addEventListener("input", debounce((event) => {
      this.desktopInput.value = this.mobileInput.value;
      this.onChange(event);
    }, 500).bind(this));

    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
  }

  handleResize() {
    const wasDesktop = this.headerInput === this.desktopInput;
    const isNowDesktop = window.innerWidth >= 990;

    this.headerInput = isNowDesktop ? this.desktopInput : this.mobileInput;
    this.searchForm = isNowDesktop ? this.desktopForm : this.mobileForm;

    if (this.isOpen && wasDesktop !== isNowDesktop) {
      this.headerInput.focus();
    }
  }

  getQuery() {
    return this.headerInput.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a') ||
      event.submitter.classList.contains("card__link")
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (this.classList.contains("search-modal__form")) {
      if (this.headerBottom) {
        this.headerBottom.classList.add("header__bottom--visible");
      }
      if (this.promoModal) {
        this.promoModal.classList.remove("search__modal--hidden");
      }
      if (this.collectionList) {
        this.collectionList.classList.remove("hidden");
      }
    }

    if (!currentSearchTerm.length) {
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
      if (this.promoModal) {
        this.promoModal.classList.add("search__modal--hidden");
      }
      if (this.collectionList) {
        this.collectionList.classList.add("hidden");
      }
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    if (this.classList.contains("search-modal__form")) {
      if (this.headerBottom) {
        this.headerBottom.classList.remove("header__bottom--visible");
      }
    }
    if (!this.classList.contains("search-modal__form")) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close(true);
      });
    }
  }

  onBlur() {
    this.headerInput.blur();
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "Enter":
        event.preventDefault();
        this.selectOption();
        break;
      case "Escape":
        this.close(true);
        this.closeResults(clearSearchTerm);
        if (this.getQuery().length) {
          this.hidePromoBlock();
        } else {
          this.showPromoBlock();
        }
        break;
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]",
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (
        currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
      ) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]',
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.promoModal && this.classList.contains("search-modal__form")) {
      this.promoModal.classList.add("search__modal--hidden");
    }

    if (this.collectionList) {
      this.collectionList.classList.add("hidden");
    }

    const quotedSearchTerm = '"' + searchTerm.trim() + '"';

    fetch(
      `${window.routes.search_url}?type=product&q=${encodeURIComponent(quotedSearchTerm)}`,
      { signal: this.abortController.signal },
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#predictive-search-results-products-list")?.outerHTML ?? '';
        this.renderSearchResults(resultsMarkup);
        this.clickSearchTabs();
        this.calcHeight();
        window.dispatchEvent(new Event('predictive-search-results-rendered'));
        try {
          colorSwatches();
        } catch (err) { }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });

    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();

    this.open();
    if (this.promoModal && this.classList.contains("search-modal__form")) {
      this.promoModal.classList.add("search__modal--hidden");
    }
    if (this.collectionList) {
      this.collectionList.classList.add("hidden");
    }
    if (this.defaultContent) {
      this.defaultContent.classList.add('hidden');
    }

    this.trackSuccessfulSearch(this.searchTerm);
  }

  clickSearchTabs() {
    const results = this.querySelectorAll(".predictive-search__results-list");
    if (results.length != 0) {
      results[0].classList.add("active");
    }
  }

  hidePromoBlock() {
    if (this.classList.contains("search-modal__form")) {
      if (this.promoModal) {
        this.promoModal.classList.add("search__modal--hidden");
      }
      if (this.collectionList) {
        this.collectionList.classList.add("hidden");
      }
      if (this.defaultContent) {
        this.defaultContent.classList.add('hidden');
      }
    }
  }

  showPromoBlock() {
    if (this.classList.contains("search-modal__form")) {
      if (this.promoModal) {
        this.promoModal.classList.remove("search__modal--hidden");
      }
      if (this.collectionList) {
        this.collectionList.classList.remove("hidden");
      }
      if (this.defaultContent) {
        this.defaultContent.classList.remove('hidden');
      }
    }
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
  }

  open() {
    this.setAttribute("open", true);
    this.headerInput.setAttribute("aria-expanded", true);
    this.isOpen = true;
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.headerInput.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.headerInput.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.headerInput.setAttribute("aria-expanded", false);
    if (this.getQuery().length) {
      this.hidePromoBlock();
    } else {
      this.showPromoBlock();
    }
  }

  getRecentSearches() {
    try {
      const searches = localStorage.getItem('recentSearches');
      return searches ? JSON.parse(searches) : [];
    } catch (e) {
      console.error('Error reading recent searches:', e);
      return [];
    }
  }

  saveRecentSearch(searchTerm) {
    try {
      const trimmedTerm = searchTerm.trim();
      if (!trimmedTerm) return;

      let searches = this.getRecentSearches();
      const lowerTrimmedTerm = trimmedTerm.toLowerCase();

      const isContainedOrContains = searches.some(existingTerm => {
        const lowerExistingTerm = existingTerm.toLowerCase();
        return lowerExistingTerm.includes(lowerTrimmedTerm) || lowerTrimmedTerm.includes(lowerExistingTerm);
      });

      if (isContainedOrContains) return;

      searches.unshift(trimmedTerm);
      searches = searches.slice(0, 12);

      localStorage.setItem('recentSearches', JSON.stringify(searches));
      this.renderRecentSearches(searches);
    } catch (e) {
      console.error('Error saving recent search:', e);
    }
  }

  loadRecentSearches() {
    const searches = this.getRecentSearches();
    this.renderRecentSearches(searches);
  }

  renderRecentSearches(searches) {
    if (!this.recentSearchesContainer || !this.recentSearchesList) return;

    if (searches.length === 0) {
      this.recentSearchesContainer.classList.add('hidden');
      return;
    }

    this.recentSearchesContainer.classList.remove('hidden');
    this.recentSearchesList.innerHTML = '';

    searches.forEach(term => {
      const li = document.createElement('li');
      li.className = 'search-default__term-item';

      const a = document.createElement('a');
      a.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(term)}`;
      a.className = 'search-default__term-link link';

      const iconSpan = document.createElement('span');
      iconSpan.className = 'search-default__term-icon';
      iconSpan.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-search" fill="none" viewBox="0 0 18 19"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 112.85 3.5a5.784 5.784 0 018.18 8.18zm.26 1.12a6.78 6.78 0 11.72-.7l5.4 5.4a.5.5 0 11-.71.7l-5.41-5.4z" fill="currentColor"/></svg>';

      const textSpan = document.createElement('span');
      textSpan.textContent = term;

      a.appendChild(iconSpan);
      a.appendChild(textSpan);
      li.appendChild(a);

      this.recentSearchesList.appendChild(li);
    });
  }

  trackSuccessfulSearch(searchTerm) {
    const resultsWrapper = this.querySelector('#predictive-search-results-products-list');
    if (resultsWrapper) {
      this.saveRecentSearch(searchTerm);
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);